/** 与 China-DiFi-Mobile tdesign_check 一致：24 描边勾，非蓝底圆勾 */
export const ActionSheetCheckIcon = () => (
  <svg
    class="action-sheet-check-icon"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.5707 7.37793L10.3797 16.5709L5.42969 11.6209"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="square"
    />
  </svg>
);
